const goToReview = () => {
    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
            var href = window.location.href;
            var TabSections = document.getElementById('ProductTab');
            var reviewSection = document.getElementById('divReview');
            var readMoreBtn = reviewSection.getElementsByClassName('read-more')[0];
            if (href.includes('#review')) {
                TabSections.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
                reviewSection.classList.remove('less-show');
                readMoreBtn.innerHTML = 'نمایش کمتر';
            }
        }, 500);
    })

}

export {
    goToReview
}